exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".news-item[data-v-fe09f402]{cursor:pointer;transition:background-color .2s ease}.news-item[data-v-fe09f402]:hover{background-color:#f8f9fa}.cursor-pointer[data-v-fe09f402]{cursor:pointer}", ""]);

// exports
